import React, { useState } from "react";

import {
  Flex,
  HStack,
  VStack,
  Text,
  Stack,
  FormControl,
  FormErrorMessage,
  Link,
  Tooltip,
  Icon,
  useBreakpointValue,
} from "@chakra-ui/react";
import { IoHelpCircle } from "react-icons/io5";
import { RadioButtonField } from "../../../../components/RadioButtonField";
import { HiSearch } from "react-icons/hi";
import { PopoverGenero } from "../../../../components/PopoverGenero";

export const RadioOptions = ({
  label,
  mt,
  fieldName,
  useYes,
  linkCertidao,
  errors,
  touched,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <HStack
      spacing={{ base: "10px", sm: "30px" }}
      mt={mt ? mt : "0px"}
      justifyContent={
        isMobile && linkCertidao ? "space-evenly" : "space-between"
      }
      pr={{ lg: "15%" }}
      alignItems="flex-start">
      <Flex
        alignItems="flex-start"
        flexDirection={{ base: "column", lg: "row" }}>
        <FormControl
          isInvalid={errors[fieldName] && touched[fieldName]}
          id={fieldName}
          w="max-content">
          <VStack alignItems="flex-start">
            <Text
              color="#5F6377"
              fontWeight={500}
              fontSize="14px"
              lineHeight="19.6px"
              minW="265px">
              {label}
            </Text>
            <FormErrorMessage>{errors[fieldName]}</FormErrorMessage>
          </VStack>
        </FormControl>
        <Stack
          direction={{ base: "column", md: "row" }}
          ml={{ base: "0px", md: "10px" }}>
          {!useYes ? (
            <RadioButtonField fieldName={fieldName} value="S" label="Sim" />
          ) : (
            <>
              <RadioButtonField
                fieldName={fieldName}
                value="F"
                label="Física"
              />
              <RadioButtonField
                fieldName={fieldName}
                value="D"
                label="Digital"
              />
            </>
          )}
          <RadioButtonField fieldName={fieldName} value="N" label="Não" />
          <RadioButtonField
            fieldName={fieldName}
            value="SI"
            label="Sem Informação"
          />
        </Stack>
      </Flex>
      {linkCertidao && (
        <Flex
          alignItems={"center"}
          flexDirection={isMobile && "column"}
          gap={2}
          size={20}>
          <Link
            display={!isMobile && "flex"}
            whiteSpace={{ base: "normal", md: "nowrap" }}
            href={linkCertidao}
            isExternal
            border={"solid 2px"}
            rounded={isMobile ? "2xl" : "full"}
            borderColor={"#DDEBEA"}
            px={1}>
            <HiSearch size={20} color="#5F6377" />
            <Text
              fontSize="14px"
              color="#5F6377"
              fontWeight={500}
              lineHeight="19.6px">
              Buscar Certidão de Nascimento
            </Text>
          </Link>
          {isMobile ? (
            <PopoverGenero
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              handleClick={handleClick}
              labelTextoGenero={
                "Informações sobre registros de nascimentos e óbitos podem ser consultadas de forma on-line e gratuita pela página da Corregedoria Geral da Justiça do Tribunal de Justiça do Rio de Janeiro, através do Portal Extrajudicial. A plataforma permite que o usuário verifique de forma rápida em qual Serviço Extrajudicial se encontra o registro de nascimento ou óbito, facilitando assim a obtenção de segundas vias de certidões. O sistema permite aos cidadãos, aos órgãos judiciais e demais órgãos públicos a obtenção de informações relativas a registros de nascimento e óbito realizados em todo o estado desde agosto de 2007."
              }
            />
          ) : (
            <Tooltip
              width={"85%"}
              textAlign="justify"
              placement="bottom-start"
              label="Informações sobre registros de nascimentos e óbitos podem ser consultadas de forma on-line e gratuita pela página da Corregedoria Geral da Justiça do Tribunal de Justiça do Rio de Janeiro, através do Portal Extrajudicial. A plataforma permite que o usuário verifique de forma rápida em qual Serviço Extrajudicial se encontra o registro de nascimento ou óbito, facilitando assim a obtenção de segundas vias de certidões.

        O sistema permite aos cidadãos, aos órgãos judiciais e demais órgãos públicos a obtenção de informações relativas a registros de nascimento e óbito realizados em todo o estado desde agosto de 2007.">
              <Flex>
                <Icon
                  aria-label="Aviso de pendente"
                  color="#6B6C71"
                  as={IoHelpCircle}
                  boxSize="20px"
                />
              </Flex>
            </Tooltip>
          )}
        </Flex>
      )}
    </HStack>
  );
};
